import { render, staticRenderFns } from "./resourceStatic.vue?vue&type=template&id=b3f7a9d2&scoped=true"
import script from "./resourceStatic.vue?vue&type=script&lang=js"
export * from "./resourceStatic.vue?vue&type=script&lang=js"
import style0 from "./resourceStatic.vue?vue&type=style&index=0&id=b3f7a9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f7a9d2",
  null
  
)

export default component.exports